import moment from 'moment';

export function MomentFilter() {
    return function(momentObject, format) {
        if (moment.isMoment(momentObject)) {
            return momentObject.format(format);
        }
        if (typeof momentObject === 'string') {
            return moment(momentObject).format(format);
        }
        return null;
    };
}
